import styled from 'styled-components';
import { NoteIconWrapperProps } from './NoteIcon.types';

export const NoteIconWrapper = styled.svg`
    cursor: ${({ clickable }: NoteIconWrapperProps) => (clickable ? 'pointer' : 'auto')};
`;
